import {
  formatDateInputValue,
  getNairobiMonth,
  getNairobiYear,
  toNairobiDate,
} from "../../utils/format";

export const UNIT_TYPE_OPTIONS = [
  "Shop / Office",
  "Warehouse",
  "Bedsitter",
  "Single",
  "Double",
  "Multi-Room",
  "1 Bedroom",
  "2 Bedroom",
  "3 Bedroom",
  "4 Bedroom",
  "Open Space",
];

export const getMissingAssignmentFields = (unit) => {
  const missing = [];
  if (!(Number(unit?.rentAmount) > 0)) missing.push("rent");
  if (!String(unit?.type || "").trim()) missing.push("type");
  return missing;
};

export const getCurrentMonthRange = () => {
  const y = getNairobiYear();
  const m = getNairobiMonth();
  const start = new Date(y, m - 1, 1);
  const end = new Date(y, m, 0);
  return { start: formatDateInputValue(start), end: formatDateInputValue(end) };
};

export const calculateFirstMonthProratedRent = (rentAmount, moveInDateValue) => {
  const rent = Number(rentAmount || 0);
  if (!(rent > 0)) return 0;

  const moveIn = toNairobiDate(moveInDateValue);
  if (!moveIn) return Math.round((rent + Number.EPSILON) * 100) / 100;

  const daysInMonth = new Date(
    moveIn.getFullYear(),
    moveIn.getMonth() + 1,
    0
  ).getDate();
  const daysRemaining = Math.max(0, daysInMonth - moveIn.getDate() + 1);
  if (!(daysInMonth > 0) || !(daysRemaining > 0)) return 0;

  return Math.round(
    (((rent / daysInMonth) * daysRemaining) + Number.EPSILON) * 100
  ) / 100;
};

export const normalizeId = (value) => {
  if (!value) return "";
  return typeof value.toString === "function" ? value.toString() : String(value);
};

export const getUserRoleChipLabel = (roleCode) => {
  switch (String(roleCode || "").toUpperCase()) {
    case "M":
      return "Management";
    case "L":
      return "Landlord";
    case "T":
      return "Tenant";
    case "A":
      return "Admin";
    case "MBR":
      return "Member";
    default:
      return roleCode || "User";
  }
};

export const getPayScoreStatusClasses = (status) => {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "excellent")
    return "bg-emerald-100 text-emerald-700 border-emerald-200";
  if (normalized === "good") return "bg-green-100 text-green-700 border-green-200";
  if (normalized === "fair") return "bg-amber-100 text-amber-700 border-amber-200";
  if (normalized === "risk") return "bg-orange-100 text-orange-700 border-orange-200";
  if (normalized === "restricted")
    return "bg-red-100 text-red-700 border-red-200";
  return "bg-gray-100 text-gray-700 border-gray-200";
};

export const formatPayScorePercent = (value) =>
  Number.isFinite(Number(value)) ? `${Number(value).toFixed(1)}%` : "--";
